import { useCallback, useState } from "react";

import { Button } from "react-bootstrap";
import PropTypes from "prop-types";

const ToggleButtonControlled = ({
    Icon1,
    Icon2,
    LoadingIcon,
    value,
    isLoading,
    onClick,
    ...rest
}) => {

    const nonLoadingIcon = value ? Icon1 : Icon2;
    const Icon = isLoading ? LoadingIcon : nonLoadingIcon;

    const click = (isLoading) ? null : onClick;

    return (
        <Button isLoading variant="link" size="sm" className="toggle-button transition m-0 p-0" disabled={isLoading} {...rest} onClick={click}>
            {Icon}
        </Button>
    );
};

const ToggleButton = ({ onToggle, initialValue = false, ...rest }) => {
    const [toggleStatus, setToggleStatus] = useState(initialValue);
    const [isLoading, setIsLoading] = useState(false);

    const handleClick = useCallback(() => {
        if (!isLoading)
        {
            if (typeof onToggle === "function") {
                const result = onToggle();

                if (
                    typeof result.then === "function" &&
                    typeof result.finally === "function"
                ) {
                    setIsLoading(true);

                    (async () => {
                        try {
                            await result;
                            setToggleStatus((toggled) => !toggled);
                        } finally {
                            setIsLoading(false);
                        }
                    })();
                } else {
                    setToggleStatus((isToggled) => !isToggled);
                }
            }
        }
    }, [onToggle, isLoading]);

    return (
        <ToggleButtonControlled
            {...rest}
            value={toggleStatus}
            isLoading={isLoading}
            onClick={handleClick}
        />
    );
};

ToggleButton.propTypes = {
    Icon1: PropTypes.element.isRequired,
    Icon2: PropTypes.element.isRequired,
    onToggle: PropTypes.func,
    LoadingIcon: PropTypes.element,
    initialValue: PropTypes.bool,
};

ToggleButtonControlled.propTypes = {
    Icon1: PropTypes.node,
    Icon2: PropTypes.node,
    LoadingIcon: PropTypes.element,
    value: PropTypes.bool,
    isLoading: PropTypes.bool,
    onClick: PropTypes.func,
};

export default ToggleButton;
export { ToggleButtonControlled };
